const DEFAULT_AFTER_LOGIN_URL = '/dashboard';

const AUTH_ROUTE_PREFIXES = [
  '/login',
  '/forgot-password',
  '/reset-password',
  '/set-new-password',
  '/unauthorized',
] as const;

export function sanitizeReturnUrl(
  value: string | null | undefined,
  fallback = DEFAULT_AFTER_LOGIN_URL,
): string {
  const decoded = decodeRepeated(value?.trim() ?? '');
  if (!decoded) {
    return fallback;
  }

  const path = toInternalPath(decoded);
  if (!path) {
    return fallback;
  }

  const routePath = path.split(/[?#]/, 1)[0] || '/';
  if (
    AUTH_ROUTE_PREFIXES.some((prefix) => routePath === prefix || routePath.startsWith(`${prefix}/`))
  ) {
    return fallback;
  }

  return path;
}

export function loginRedirectExtras(returnUrl: string | null | undefined): {
  queryParams?: { returnUrl: string };
} {
  const safeReturnUrl = sanitizeReturnUrl(returnUrl);
  return safeReturnUrl === DEFAULT_AFTER_LOGIN_URL ? {} : { queryParams: { returnUrl: safeReturnUrl } };
}

function decodeRepeated(value: string): string {
  let decoded = value;

  for (let i = 0; i < 5; i += 1) {
    try {
      const next = decodeURIComponent(decoded);
      if (next === decoded) {
        break;
      }
      decoded = next;
    } catch {
      break;
    }
  }

  return decoded;
}

function toInternalPath(value: string): string | null {
  if (value.startsWith('//')) {
    return null;
  }

  if (value.startsWith('/')) {
    return value;
  }

  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const parsed = new URL(value, window.location.origin);
    if (parsed.origin !== window.location.origin) {
      return null;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}` || '/';
  } catch {
    return null;
  }
}
